import { Splide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/react-splide/dist/css/splide-core.min.css'
import styles from './style.styl'

export const Slider = ({ children, className, options, ...rest }) => (
  <Splide
    className={styles.splide}
    options={{ type: 'loop', perPage: 1, gap: '0.535714285714286rem', padding: { left: '0.535714285714286rem', right: 'calc(0.535714285714286rem * 2)' }, ...options }}
    hasTrack={false}
    {...rest}
  >
    <SplideTrack className={styles.sliderTrack}>{children}</SplideTrack>
  </Splide>
)



// WEBPACK FOOTER //
// ./components/slider/index.js